import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }

import useScanPlaceResult from './_inner/useScanPlaceResult';
import { BasicLoading } from '@components/basic'
import { IonPage, IonContent, } from '@ionic/vue';
import { toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScanPlaceResultView',
  setup(__props) {

const { placeData, placeCode, resultViewComponent, form } =
  useScanPlaceResult();

const { isLoading } = toRefs(form)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          (_unref(isLoading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(BasicLoading), { "is-loading": _unref(isLoading) }, null, 8, ["is-loading"])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(resultViewComponent)), {
            item: _unref(placeData),
            code: _unref(placeCode)
          }, null, 8, ["item", "code"]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})